var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBonus24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_bonus24x24",
    transform: "translate(-3 -4.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(3 4.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(1.023 8.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M32,271.692v6.138a1.024,1.024,0,0,0,1.023,1.023h5.115v-7.161Z",
    transform: "translate(-32 -271.692)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M15,20.38H11.836a3.9,3.9,0,0,0,.558-.455,2.173,2.173,0,0,0,0-3.01,2.079,2.079,0,0,0-2.933,0c-.434.445-1.584,2.257-1.422,3.468H7.964c.158-1.21-.992-3.022-1.422-3.468a2.08,2.08,0,0,0-2.933,0,2.177,2.177,0,0,0,0,3.01,3.974,3.974,0,0,0,.559.455H1A1.014,1.014,0,0,0,0,21.4V22.94a.506.506,0,0,0,.5.512H7V21.405H9v2.046h6.5a.506.506,0,0,0,.5-.512V21.4a1.013,1.013,0,0,0-1-1.023Zm-8.059-.034a.323.323,0,0,1-.185.034A4.871,4.871,0,0,1,4.316,19.2a1.134,1.134,0,0,1,0-1.568,1.05,1.05,0,0,1,1.511,0C6.5,18.329,7.174,20.1,6.941,20.347Zm2.3.034c-.142,0-.184-.033-.184-.034-.233-.246.437-2.019,1.111-2.712a1.06,1.06,0,0,1,1.486.047,1.121,1.121,0,0,1,.025,1.521A4.87,4.87,0,0,1,9.244,20.38Z",
    transform: "translate(0 -16.31)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(8.838 8.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M288,271.692v7.161h5.115a1.023,1.023,0,0,0,1.023-1.023v-6.138Z",
    transform: "translate(-288 -271.692)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBonus24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bonus24x24.bcca4818bfd9cdb1a5cabb8e43371c56.svg";